stripHash